import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import { url } from '../../../js/api/endpoint';
import user from '../../../js/stores/user.js';
import themes from '../../../js/stores/theme.js';
import language from '../../../js/stores/language.js';
import carLoan from '../../../js/stores/car-loan.js';
import file from '../../../js/stores/file.js';
import * as dayjs from 'dayjs';
import GoogleMapItem from '../../components/google-map.f7.html';
var AppointmentTab = function AppointmentTab(props, _ref) {
  var $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var data = props.data;
  var appointmentDateTime;
  var isOwner = user.getters.carId.value == props.data.CarMainData.CarId ? true : false;
  var isBorrower = user.getters.carId.value != props.data.CarMainData.CarId ? true : false;
  var isDisabled = true;
  var driverLicensePhotos = [];
  var driverLicenseBrowser;
  var openDriverBrowser = function openDriverBrowser() {
    driverLicenseBrowser.open();
  };
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var timeElapsed, today, driverLicenseFiles, fileIds, i, urlFile;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          isDisabled = props.data.CarLoanData.CarLoanStatusId == 3 ? false : true;
          timeElapsed = Date.now();
          today = new Date(timeElapsed);
          appointmentDateTime = $f7.calendar.create({
            inputEl: '#appointment-date',
            openIn: 'customModal',
            timePicker: true,
            footer: true,
            toolbarCloseText: locale.translate('general.done'),
            disabled: {
              from: new Date(2000, 0, 1),
              to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
            },
            on: {
              closed: function closed(e) {
                if (e.value === undefined) return;
                var dates = e.value;
                var startDate = dayjs(dates[0]).format('YYYY-MM-DD HH:mm:00');
                document.getElementById("appointment-date").value = "".concat(startDate);
              }
            }
          });
          _context.next = 1;
          return file.dispatch('getDriverLicense', data.CarMainData.ContactId);
        case 1:
          driverLicenseFiles = _context.sent;
          fileIds = [];
          driverLicensePhotos = [];
          for (i = 0; i < driverLicenseFiles.length; i++) {
            fileIds.push(driverLicenseFiles[i].FileId);
            if (!(driverLicenseFiles[i].FilePath.length == 0 && driverLicenseFiles[i].FileName.length == 0)) {
              urlFile = "".concat(url, "/").concat(driverLicenseFiles[i].FilePath, "/").concat(driverLicenseFiles[i].FileName);
              driverLicensePhotos.push(urlFile);
            }
          }
          if (driverLicensePhotos.length > 0) {
            driverLicenseBrowser = $f7.photoBrowser.create({
              photos: driverLicensePhotos,
              theme: themes.getters.Name.value
            });
          }
          $update();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var showAppointmentDialog = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            appointmentDateTime.open();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function showAppointmentDialog() {
      return _ref3.apply(this, arguments);
    };
  }();
  var setAppointment = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var appointmentDate, appointmentPlace, formData;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            //let isInsuranceAdded = document.getElementById('is-insurance-added').checked ? 1 : 0;
            appointmentDate = appointmentDateTime.value;
            appointmentPlace = document.getElementById('appointment-place-address').value; // if (!document.getElementById('is-insurance-added').checked) {
            //   $f7.toast.show( { text: locale.translate('loan.appointment.confirmAddedInsurance')} );
            //   document.getElementById('is-insurance-added').focus();
            //   return;
            // }
            if (!(appointmentDate == undefined || appointmentDate.length < 1)) {
              _context4.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.appointment.noAppointmentSelected')
            });
            return _context4.abrupt("return");
          case 1:
            if (!(appointmentPlace === "")) {
              _context4.next = 2;
              break;
            }
            $f7.toast.show({
              text: locale.translate('loan.appointment.noPlaceEntered')
            });
            return _context4.abrupt("return");
          case 2:
            formData = $f7.form.convertToData('#appointment-form'); //formData['IsInsuranceAdded'] = isInsuranceAdded;
            formData['CarLoanStartDate'] = data.CarLoanData.CarLoanStartDate;
            formData["CarLoanId"] = data.CarLoanData.CarLoanId;
            formData["CarId"] = data.CarMainData.CarId;
            formData["LenderId"] = data.CarMainData.ContactId;
            formData["BorrowerId"] = data.CarLoanData.BorrowerId;
            $f7.dialog.confirm(locale.translate('loan.appointment.confirmMeeting', [appointmentDate, appointmentPlace]), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var result;
              return _regeneratorRuntime.wrap(function (_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 1;
                    return carLoan.dispatch('setAppointment', formData);
                  case 1:
                    result = _context3.sent;
                    if (!(result.status !== undefined && result.status !== 200)) {
                      _context3.next = 2;
                      break;
                    }
                    $f7.toast.show({
                      text: result.data.messages.error
                    });
                    return _context3.abrupt("return");
                  case 2:
                    $f7.toast.show({
                      text: locale.translate('loan.appointment.messageMeeting', [appointmentDate, appointmentPlace])
                    });
                    $f7.views.main.router.navigate('/', {
                      reloadCurrent: true,
                      ignoreCache: true
                    });
                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            })));
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function setAppointment() {
      return _ref4.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page-content tab" id="tab-4-appointment">
  <div class="block">
    <div>
      ${locale.translate('loan.appointment.pleaseNote')}:
      <ul>
        <li>
          ${locale.translate('loan.appointment.notRenting')}
        </li>
        <li>
          ${locale.translate('loan.appointment.noLawIssues')}
        </li>
        <li>
          ${locale.translate('loan.appointment.agreedOnRequirements')}
        </li>
        <li>
          ${locale.translate('loan.appointment.insuranceFrom')}: <a class="link external" target="_system" href="https://www.ohra.nl/leenAutoverzekering.nl">OHRA</a>
        </li>
      </ul>
    </div>
    <div id="lender-data-section">
      <table>
        <tr>
          <td>${locale.translate('user.edit.personal.contactFirstName')}</td>
          <td>${props.data.DriverData.ContactName}</td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.personal.contactLastName')}</td>
          <td>${props.data.DriverData.ContactFirstLastName}</td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.personal.contactGenderLabel')}</td>
          <td>
            ${props.data.DriverData.ContactSex == 1 ? $h`${locale.translate('user.edit.personal.contactGenderMale')}` : $h`<span></span>`}
            ${props.data.DriverData.ContactSex == 2 ? $h`${locale.translate('user.edit.personal.contactGenderFemale')}` : $h`<span></span>`}
            ${props.data.DriverData.ContactSex == 3 ? $h`${locale.translate('user.edit.personal.contactGenderX')}` : $h`<span></span>`}
          </td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.personal.contactBirthDateLabel')}</td>
          <td>${props.data.DriverData.ContactBirthDate}</td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.location.addressLabel')}</td>
          <td>${props.data.DriverData.ContactAddress}</td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.location.streetLabel')}</td>
          <td>${props.data.DriverData.ContactAddressStreet}</td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.location.externalNumber')}</td>
          <td>${props.data.DriverData.ContactAddressExteriorNumber}</td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.location.district')}</td>
          <td>${props.data.DriverData.ContactDistrict}</td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.location.zipCode')}</td>
          <td>${props.data.DriverData.ContactZipcode}</td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.location.phone')}</td>
          <td>${props.data.DriverData.ContactCellphone}</td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.location.email')}</td>
          <td>${props.data.DriverData.ContactEmail}</td>
        </tr>
        <tr>
          <td>${locale.translate('user.edit.location.locality')}</td>
          <td>${props.data.DriverData.ContactLocalityName}</td>
        </tr>
      </table>
    </div>
    <form id="appointment-form" class="list no-hairlines-md ${isDisabled ? $h`disabled` : $h``}">
      <div class="block-title">${locale.translate('loan.appointment.labelData')}</div>
      <div class="list">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('loan.appointment.selectAppointmentDate')}</div>
              <div class="item-input-wrap">
                <input id="appointment-date" name="CarAppointmentDate" type="text" autocomplete="off" placeholder="${locale.translate('general.date')}"
                  readonly="readonly" @click="${showAppointmentDialog}" value="${props.data.CarLoanData.AppointmentDate}" />
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${locale.translate('loan.appointment.selectAppointmentPlace')}</div>
              <div class="item-input-wrap">
                <input id="appointment-place-address" name="CarAppointmentAddress" type="text" autocomplete="off" placeholder="${locale.translate('general.place')}" value="${props.data.AppointmentData.CarAppointmentAddress}"/>
                <input id="appointment-place-coords-latitude" name="CarAppointmentLatitude" type="hidden" value="${props.data.AppointmentData.CarAppointmentLatitude}"/>
                <input id="appointment-place-coords-longitude" name="CarAppointmentLongitude" type="hidden" value="${props.data.AppointmentData.CarAppointmentLongitude}"/>
              </div>
            </div>
            <div class="item-after">
              <a href="#" class="button button-fill button-raised popup-open location-button" data-popup=".appointment-popup">
                <i class="icon material-symbols-outlined">location_on</i>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </form>
    ${props.data.CarLoanData.CarLoanStatusId > 3 ? $h`
    <div class="list">
      <ul>
        <li>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title">
                <a class="link external" target="_system" href="https://www.google.com/maps/place/${props.data.AppointmentData.CarAppointmentLatitude},${props.data.AppointmentData.CarAppointmentLongitude}">
                  ${props.data.AppointmentData.CarAppointmentAddress}
                  <i class="icon material-symbols-outlined">location_on</i>
                </a>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    ` : $h`
    <span></span>
    `}
    <div class="block block-strong ${isDisabled ? $h`disabled` : $h``}">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill color-lime ${driverLicensePhotos.length < 1  && $h`disabled`}" @click=${openDriverBrowser}>
            <span class="material-symbols-outlined">image</span>${locale.translate('user.edit.personal.viewLicense')}
          </a>
        </div>
        <div></div>
      </p>
    </div>
    ${!isDisabled && isOwner ? $h`
    <div class="block block-strong">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill button-raised color-green" @click="${setAppointment}">
            <span class="material-symbols-outlined">file_map</span>${locale.translate('general.accept')}
          </a>
        </div>
        <div></div>
      </p>
    </div>
    ` : $h`
    <span></span>
    `}
  </div>
  <${GoogleMapItem} selector="appointment"/>
</div>
`
    }
    ;
};
export default AppointmentTab;